import { Outlet } from "react-router-dom";
import type { ReactNode } from "react";
import { Header } from "./Header.js";
import { Sidebar } from "./Sidebar.js";

/**
 * Shell de três regiões (Design.md §4): menu lateral persistente, cabeçalho e
 * área de conteúdo rolável. As rotas filhas renderizam no `<Outlet/>`.
 */
export function AppShell(): ReactNode {
  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "var(--bg)" }}>
      <Sidebar />
      <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>
        <Header />
        <main
          style={{
            flex: 1,
            overflow: "auto",
            padding: "1.25rem 1.5rem"
          }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
